import { useMemo, useState } from "react";
import { collectionItems, collectionTabs } from "@/mocks/home";

const toNumber = (v: string) => Number.parseFloat(v.replace("万", "")) || 0;

export default function FeaturedCollections() {
  const [tab, setTab] = useState("latest");

  const items = useMemo(() => {
    const list = [...collectionItems];
    if (tab === "hot") {
      list.sort((a, b) => toNumber(b.readCount) - toNumber(a.readCount));
    } else if (tab === "archive") {
      list.reverse();
    }
    return list;
  }, [tab]);

  const featured = items[0];
  const rest = items.slice(1);

  return (
    <section id="collections" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">
              COLLECTIONS
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              爆料合集 · 大小卡混排
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              把零散的热门爆料按主题打包成合集，按时间线或热度重新排序，一条一条看不会乱。
            </p>
          </div>

          <div className="inline-flex items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1 self-start md:self-auto">
            {collectionTabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`rounded-full px-4 py-2 text-sm transition-colors whitespace-nowrap cursor-pointer ${
                  tab === t.key
                    ? "bg-foreground-950 text-background-50 font-medium"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {featured && (
            <article className="sm:col-span-2 group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300">
              <div className="relative w-full h-56 md:h-72">
                <img
                  src={featured.image}
                  alt={featured.title}
                  title={`${featured.title} - 黑料平台爆料合集`}
                  className="w-full h-full object-cover object-top"
                />
                <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50 dark:text-foreground-950">
                  {featured.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-bold leading-snug text-foreground-950">
                  {featured.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {featured.desc}
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </span>
                    {featured.readCount} 阅读
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-time-line"></i>
                    </span>
                    更新于 {featured.updated}
                  </span>
                </div>
              </div>
            </article>
          )}

          {rest.map((c) => (
            <article
              key={c.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="w-full h-32">
                <img
                  src={c.image}
                  alt={c.title}
                  title={`${c.title} - 黑料平台吃瓜合集`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex flex-1 flex-col p-4">
                <span className="self-start rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                  {c.tag}
                </span>
                <h3 className="mt-2.5 text-sm font-medium leading-snug text-foreground-950">
                  {c.title}
                </h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-500">
                  {c.desc}
                </p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                  <span>{c.readCount} 阅读</span>
                  <span>{c.updated}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}